module.exports = __webpack_public_path__ + "static/img/12.9f142f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/12.png
// module id = ErOG
// module chunks = 0